import { Injectable } from '@angular/core';
import { ControlResizerOptions } from './control-resizer-options';

@Injectable({
  providedIn: 'root'
})

export class ControlResizerService {
  private defaultOptions: ControlResizerOptions = new ControlResizerOptions();

  /*
    Calculate from the effective inner screen height an adjusted height that would fit within the view.

    Nesting can be achieved by the user supplying an element offset calculated previously from the top of the screen and supplied in the input options.

    If a top element offset is not provided then the height uses the offset taken from the height of the header & sub header/menu

    Margin values are provided by supplying offset top and bottom heights

    The height for the footer is used in all cases
  */

  public calculateHeight(options?: ControlResizerOptions): number {

    const effectiveOptions = { ...this.defaultOptions, ...options };

    var contentHeight: number = 0;

    if (!!effectiveOptions.elemTop) {

      contentHeight = effectiveOptions.screenHeight
        - effectiveOptions.elemTop 
        - effectiveOptions.offsetTopHeight
        - effectiveOptions.offsetBottomHeight
        - effectiveOptions.footerHeight;
    }
    else {

      contentHeight = effectiveOptions.screenHeight
        - effectiveOptions.headerHeight
        - effectiveOptions.subMenuHeight
        - effectiveOptions.offsetTopHeight
        - effectiveOptions.offsetBottomHeight
        - effectiveOptions.footerHeight;
    }

    // Do not return negative heights
    contentHeight = (contentHeight < 0) ? 0 : contentHeight;
    
    return contentHeight;
  }
}
